var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-card',{staticClass:"elevation-3 m-t-30"},[_c('f7-card-header',{staticClass:"bg-madai text-white bold p-l-10 m-b-0"},[_vm._v("Anillo Ricardo Gtz.")]),_c('f7-card-content',{staticStyle:{"padding":"10px","border-bottom":"2px solid #293061"}},[_c('f7-photo-browser',{ref:"edgar",attrs:{"navbar-of-text":"de","photos":[
        {
          caption: 'Modelo 3D',
          url: '//movil.madai.mx/360/ricardo/modelo3d1.jpg'
        },
        {
          caption: 'Modelo 3D',
          url: '//movil.madai.mx/360/ricardo/modelo3d2.jpg'
        },
        {
          caption: 'Modelo 3D',
          url: '//movil.madai.mx/360/ricardo/modelo3d3.jpg'
        },
        {
          caption: 'Render',
          url: '//movil.madai.mx/360/ricardo/render1.jpg'
        },
        {
          caption: 'Render',
          url: '//movil.madai.mx/360/ricardo/render2.jpg'
        },
        {
          caption: 'Render',
          url: '//movil.madai.mx/360/ricardo/render3.jpg'
        },
        {
          caption: 'Resina',
          url: '//movil.madai.mx/360/ricardo/resina1.jpg'
        },
        {
          caption: 'Resina',
          url: '//movil.madai.mx/360/ricardo/resina2.jpg'
        },
        {
          caption: 'Vaciado',
          url: '//movil.madai.mx/360/ricardo/vaciado1.jpg'
        },
        {
          caption: 'Vaciado',
          url: '//movil.madai.mx/360/ricardo/vaciado2.jpg'
        },
        {
          caption: 'Final',
          url: '//movil.madai.mx/360/ricardo/final1.jpg'
        },
        {
          caption: 'Final',
          url: '//movil.madai.mx/360/ricardo/final2.jpg'
        }
      ],"type":"popup","theme":"dark"}}),_c('f7-row',[_c('f7-col',[_c('div',{staticClass:"embed"},[_c('iframe',{staticClass:"border-0",attrs:{"src":"//movil.madai.mx/360/ricardo/360/index.html","scrolling":"no","height":"200"}})])])],1)],1),_c('f7-card-footer',{staticStyle:{"background-color":"rgba(158, 158, 158, 0.13)"}},[_c('div',{staticClass:"wd-100"},[_c('f7-block',{staticClass:"m-t-10 p-0"},[_c('span',{staticClass:"text-madai bold m-b-0 fs-16"},[_vm._v("Etapas del proyecto")]),_c('hr')]),_c('f7-swiper',{ref:"swiper",staticClass:"m-t-20 p-b-40",attrs:{"pagination":"","params":{speed:500, slidesPerView: 4}}},[_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/ricardo/modelo3d1.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(0)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("modelo 3d")])]),_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/ricardo/render3.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(3)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("render")])]),_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/ricardo/resina1.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(6)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("resina")])]),_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/ricardo/vaciado1.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(8)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("vaciado")])]),_c('f7-swiper-slide',{staticClass:"text-center"},[_c('img',{staticStyle:{"border":"3px solid #293061","border-radius":"50%","width":"60px","height":"60px"},attrs:{"src":"//movil.madai.mx/360/ricardo/final1.jpg","alt":""},on:{"click":function($event){return _vm.$refs.edgar.open(10)}}}),_c('div',{staticClass:"text-center bold text-black text-uppercase fs-14"},[_vm._v("final")])])],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }